import { useSyncExternalStore } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

import {
  MUI_LOCALE_MAPPING,
  type SUPPORTED_LANGUAGE,
} from "shared/locale/constants";
import {
  getUserLocale,
  subscribeToLanguageChange,
} from "shared/locale/getUserLocale";
import { EventTypeEnum } from "shared/types";

export const useUserLocale = (): string =>
  useSyncExternalStore(subscribeToLanguageChange, getUserLocale);

// Reads i18n directly instead of through useTranslation, which suspends while
// the locale files load.
export const useMuiLocales = () =>
  useSyncExternalStore(
    subscribeToLanguageChange,
    () =>
      MUI_LOCALE_MAPPING[i18n.resolvedLanguage as SUPPORTED_LANGUAGE] ??
      MUI_LOCALE_MAPPING.en
  );

export const useEventTypeLabel = (
  eventType: EventTypeEnum | string,
  count: number = 1
): string => {
  const { t } = useTranslation("common");

  const key = `event_type.${eventType.toLowerCase()}`;
  const value = t(key, { count });

  if (value === key) {
    console.warn(`Missing translation for key: ${key}`);
  }

  return value;
};

export const useEntityWithExternalIDTitle = (
  eventType: EventTypeEnum | string,
  externalID?: string | null
): string => {
  const label = useEventTypeLabel(eventType);

  return externalID ? `${label}: ${externalID}` : label;
};
